module.exports = __webpack_public_path__ + "img/1697164368364-WhatsApp Image 2023-10-13 at 10.29.40.jpeg.5ca16e16.webp";